// need to write mobile menu code here
const headerMenu = document.getElementsByClassName("header-menu--mobile")[0];
const mobileMenuButton = document.getElementById("mobile-menu-js");
const mobileMenuHiddenContainer = document.getElementById("mobile-menu-accordion-js");
const activeClass = "mobile-accordion--active";
const offsetMenuDistance = headerMenu.offsetTop + headerMenu.offsetHeight;
const desktopItemsWithChildren = document.getElementsByClassName("has-children");

mobileMenuButton.addEventListener("click", () => {
  const menuActive = mobileMenuHiddenContainer.classList.contains("mobile-accordion--active");
  const body = document.body;
  if (!menuActive) {
    if (typeof window.closeSearch === "function") {
      window.closeSearch();
    }
    window.scrollTo(0, 0);
    body.classList.add("window-hidden");
    mobileMenuHiddenContainer.style.cssText = `height: calc(100% - ${offsetMenuDistance}px)`;
    mobileMenuHiddenContainer.classList.add("mobile-accordion--active");
    mobileMenuButton.classList.add("mobile-menu--active");
  } else {
    body.classList.remove("window-hidden");
    mobileMenuHiddenContainer.classList.remove("mobile-accordion--active", "sub-menu__active");
    mobileMenuHiddenContainer.style.cssText = "";
    mobileMenuButton.classList.remove("mobile-menu--active");

    mobileMenuHiddenContainer.querySelectorAll("input[type='checkbox']").forEach((item) => {
      return item.checked = false;
    })
  }
});

const blurContainer = document.getElementById("blur-overlay-js");

Array.from(desktopItemsWithChildren).map((item) => {
  item.addEventListener("mouseenter", () => {
    blurContainer.classList.add("blur--active");
  });

  item.addEventListener("mouseleave", () => {
    blurContainer.classList.remove("blur--active");
  });
});

const desktopHeader = document.getElementById("header-menu--desktop-js");
const desktopHeaderSpacer = document.getElementById("header-spacer");
const deskTopHamburgerButton = document.getElementById("desktop-menu-button-js");
let menuEnabled = false;

const setHeaderSpacing = () => {
  desktopHeaderSpacer.style.marginBottom = `0px`;
};

setHeaderSpacing();

const toggleMenu = () => {
  setHeaderSpacing();

  if (menuEnabled) {
    desktopHeader.classList.remove("sticky-menu--show-menu");
    menuEnabled = false;
  } else {
    desktopHeader.classList.add("sticky-menu--show-menu");
    menuEnabled = true;
  }
};

document.addEventListener("scroll", () => {
  if (window.scrollY > 180) {
    desktopHeader.classList.add("sticky-menu--active");
    deskTopHamburgerButton.addEventListener("click", toggleMenu);
  } else {
    desktopHeader.classList.remove("sticky-menu--active");
    deskTopHamburgerButton.addEventListener("click", toggleMenu);
    desktopHeader.classList.remove("sticky-menu--show-menu");
    menuEnabled = false;
  }
});

const dropdownBlocks = document.getElementsByClassName("header-menu--child-container");

if (dropdownBlocks && dropdownBlocks.length) {
  Array.from(dropdownBlocks).map((dropdownBlock) => {
    dropdownBlock.style.display = "block";
    const blockDimensions = dropdownBlock.getBoundingClientRect();
    const blockRightOffset = blockDimensions.x + dropdownBlock.offsetWidth;

    dropdownBlock.style.display = null;

    if (blockRightOffset > window.innerWidth) {
      dropdownBlock.style.left = `-${blockRightOffset - window.innerWidth + 10}px`;
    }
  });
}

const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      calculateShipping(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function calculateShipping(cartJson) {
  console.log("calculate new shipping");
  const parsedJSON = JSON.parse(cartJson);

  const allQtyElements = document.querySelectorAll('[data-header-cart-count]');

  if(!allQtyElements || !cartJson || !parsedJSON || !parsedJSON.item_count) {
      return;
  }

  return allQtyElements.forEach((item) => item.setAttribute('data-header-cart-count', parsedJSON.item_count));

}